import { useState } from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
/* import {
  DownloadIcon,
} from 'components/atoms/Icons/iconList'; */
import VideoCard from 'components/molecules/videoCard';
import CarouselWithControls from './CarouselWithControls';
import { styleListMarkers } from './richText';

function toHtml(html) {
  return { __html: styleListMarkers(DOMPurify.sanitize((html || '').replace(/\n/g, '<br />'))) };
}

const ALIGNMENT_CLASSES = {
  left: 'md:text-left',
  center: 'md:text-center',
  right: 'md:text-right',
};

export default function ContactResources({ data }) {
  const [stopSignal, setStopSignal] = useState(0);
  const videos = (data?.elements || [])
    .filter((item) => item?.enabled)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  const alignmentClass = ALIGNMENT_CLASSES[data?.alignment] || ALIGNMENT_CLASSES.left;

  return (
    <section className='mt-[60px] md:mt-[80px]'>

      <div className='mb-[32px] flex flex-col gap-[20px] md:flex-row md:items-start md:justify-between'>
        <div className={`w-full text-center ${alignmentClass}`}>
          <h2
            className='contact-page-rte text-[26px] font-bold leading-[30px] text-black md:text-[38px] md:leading-[44px]'
            dangerouslySetInnerHTML={toHtml(data?.title)}
          />

          {data?.subtitle && (
            <p
              className='contact-page-rte mx-auto mt-[12px] max-w-[340px] text-[14px] leading-[24px] text-black md:max-w-none md:text-[16px]'
              dangerouslySetInnerHTML={toHtml(data.subtitle)}
            />
          )}
        </div>

        {/* {data?.buttonText && (
        <div className='flex justify-center md:shrink-0 md:justify-end'>
          <button
            type='button'
            className='inline-flex h-[43px] w-full max-w-[340px] items-center justify-center gap-[10px] rounded-[36px] bg-[#39A9F7] px-[24px] text-white transition hover:bg-[#2c9be8] md:h-[46px] md:w-auto md:max-w-none'
          >
            <span className='text-[16px] font-medium leading-[100%] md:text-[18px]'>
              {data.buttonText}
            </span>

            <span className='flex items-center [&>svg]:h-[15px] [&>svg]:w-[15px] md:[&>svg]:h-[18px] md:[&>svg]:w-[18px]'>
              <DownloadIcon />
            </span>
          </button>
        </div>
        )} */}
      </div>

      <CarouselWithControls
        items={videos}
        loop={data?.loop}
        slideClassName='w-full'
        paginationClassName='contact-resources-pagination'
        onNavigate={() => setStopSignal((s) => s + 1)}
        breakpoints={{
          0: { slidesPerView: 1, spaceBetween: 16 },
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
        }}
        renderItem={(video, index, activeIndex) => (
          <VideoCard
            element={video}
            isActive={index === activeIndex}
            stopSignal={stopSignal}
            body={(
              <div className='mt-[16px]'>
                <div className='flex items-start justify-between gap-[12px]'>
                  <h3
                    className='contact-page-rte text-[18px] font-bold leading-[24px] text-black md:text-[22px] md:leading-[28px]'
                    dangerouslySetInnerHTML={toHtml(video.title)}
                  />
                </div>

                {video.body && (
                <p
                  className='contact-page-rte mt-[10px] text-[14px] font-normal leading-[21px] text-black'
                  dangerouslySetInnerHTML={toHtml(video.body)}
                />
                )}
              </div>
)}
          />
        )}
      />

    </section>
  );
}

ContactResources.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    alignment: PropTypes.oneOf(['left', 'center', 'right']),
    buttonText: PropTypes.string,
    loop: PropTypes.bool,
    elements: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        body: PropTypes.string,
        thumbnailUrl: PropTypes.string,
        videoUrl: PropTypes.string,
        likes: PropTypes.number,
        order: PropTypes.number,
        enabled: PropTypes.bool,
      }),
    ),
  }),
};

ContactResources.defaultProps = {
  data: null,
};
